import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type AiProviderKindsFetchFailedAction = {
	type: 'AI_PROVIDER_KINDS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): AiProviderKindsFetchFailedAction => ({
	type: 'AI_PROVIDER_KINDS_FETCH_FAILED',
	payload,
});
